export default __webpack_public_path__ + "static/media/006-pompom-purple.ad65f12a.svg";